import { SaleInvoiceUpsertSidepanelQuery } from 'generated/resources/graphql'

import { FieldComplianceExtraField } from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/SaleInvoiceForm/types'

type FinanceFinancialDocumentComplianceExtraFieldsConfig = NonNullable<
  SaleInvoiceUpsertSidepanelQuery['finance']['financialDocumentComplianceExtraFieldsConfigs']
>[number]

export function getUpdatedComplianceExtraFields(
  oldFields: FieldComplianceExtraField[],
  newFields: FieldComplianceExtraField[],
  lineItemId: string,
  complianceExtraFieldsConfig: FinanceFinancialDocumentComplianceExtraFieldsConfig
): FieldComplianceExtraField[] {
  const updatedComplianceExtraFields = [...oldFields]

  newFields.forEach((complianceExtraField) => {
    const configField = complianceExtraFieldsConfig.fields.find(
      (config) => config.name === complianceExtraField.name
    )

    const index = updatedComplianceExtraFields.findIndex(
      (item) => item.associatedFieldId === lineItemId && item.name === complianceExtraField.name
    )
    if (index !== -1) {
      updatedComplianceExtraFields[index] = {
        ...updatedComplianceExtraFields[index],
        name: complianceExtraField.name,
        value: complianceExtraField.value,
        mandatoryForCreditNote: configField?.mandatoryForCreditNote ?? false,
        mandatoryForStandardInvoice: configField?.mandatoryForStandardInvoice ?? false,
        associatedFieldId: lineItemId,
      }
    } else {
      updatedComplianceExtraFields.push({
        name: complianceExtraField.name,
        value: complianceExtraField.value,
        mandatoryForCreditNote: configField?.mandatoryForCreditNote ?? false,
        mandatoryForStandardInvoice: configField?.mandatoryForStandardInvoice ?? false,
        associatedFieldId: lineItemId,
      })
    }
  })
  return updatedComplianceExtraFields
}
